import { render, staticRenderFns } from "./PoweredByFoot.vue?vue&type=template&id=074efda0&"
import script from "./PoweredByFoot.vue?vue&type=script&lang=js&"
export * from "./PoweredByFoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports